function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const Schedule = require('../entities/schedule');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const AccessContext = require('./contexts/access-context');

const {
  newScheduleDates,
  serializeDate
} = require('../utils/dates');

const createFields = ['id', 'type', 'startDate', 'endDate', 'weekDays', 'minutes'];
const detailsFields = ['type', 'startDate', 'endDate', 'weekDays', 'minutes'];

class ScheduleRepo {
  constructor(client
  /*: ApiClient*/
  , scheduleId
  /*: string*/
  ) {
    this.client = client;
    this.scheduleId = scheduleId;
  }

  details()
  /*: Promise<Schedule>*/
  {
    const _this = this;

    return _call(function () {
      const scheduleId = _this.scheduleId;
      const path = `/schedules/${scheduleId}`;
      const req = new _this.client.Request(path, {}, detailsFields);
      req.parse = Schedule.fromJson;
      return _await(_this.client.get(req), function (schedule) {
        // FIXME: Why can't we request `id` on this endpoint?
        schedule.id = _this.scheduleId;
        return schedule;
      });
    });
  }

}

class SchedulesRepo {
  constructor(client
  /*: ApiClient*/
  , context
  /*: AccessContext*/
  , offerId
  /*: string*/
  ) {
    this.client = client;

    this.for = scheduleId => new ScheduleRepo(this.client, scheduleId);
  }

  create(schedule
  /*: Schedule | Object*/
  , isCollection
  /*: boolean*/
  = false)
  /*: Promise<Schedule>*/
  {
    /* eslint-disable no-param-reassign */
    const advanced = isCollection ? true : schedule.advanced;
    const evergreen = isCollection ? false : schedule.evergreen;
    schedule = schedule instanceof Schedule ? schedule : new Schedule({ ...schedule,
      advanced,
      evergreen
    });
    /* eslint-enable no-param-reassign */

    const path = `/schedules`;
    const req = new this.client.Request(path, schedule, createFields);
    req.serialize = Schedule.serialize;
    req.parse = Schedule.fromJson;
    return this.client.post(req);
  } // eslint-disable-next-line class-methods-use-this


  initialize(initVals
  /*: Object*/
  = {})
  /*: Schedule*/
  {
    const {
      currentDate,
      yearFromCurrentDate
    } = newScheduleDates();
    const params = Object.assign({
      startDate: serializeDate(currentDate),
      endDate: serializeDate(yearFromCurrentDate),
      weekDays: [0, 1, 2, 3, 4, 5, 6],
      timeRanges: [['00:00', '00:00']],
      evergreen: true,
      advanced: false
    }, initVals);
    return new Schedule(params);
  }

}

module.exports = SchedulesRepo;